import { useEffect, useRef, useState } from "react";
import { Timer } from "lucide-react";
import { cn } from "@/lib/utils";

export function AptitudeTimer({ seconds, onExpire, testId = "aptitude-timer" }) {
  const [remaining, setRemaining] = useState(seconds);
  const expiredRef = useRef(false);

  useEffect(() => {
    setRemaining(seconds);
    expiredRef.current = false;
  }, [seconds]);

  useEffect(() => {
    if (remaining <= 0) {
      if (!expiredRef.current) {
        expiredRef.current = true;
        onExpire?.();
      }
      return;
    }
    const t = setTimeout(() => setRemaining((r) => r - 1), 1000);
    return () => clearTimeout(t);
  }, [remaining, onExpire]);

  const mins = Math.floor(Math.max(0, remaining) / 60);
  const secs = Math.max(0, remaining) % 60;
  const low = remaining <= 10;

  return (
    <div
      data-testid={testId}
      className={cn(
        "inline-flex items-center gap-2 rounded-full border px-4 py-1.5 font-mono text-sm font-semibold transition-colors",
        low ? "border-rose-300 bg-rose-50 text-rose-600 animate-pulse" : "border-indigo-200 bg-indigo-50 text-indigo-700"
      )}
    >
      <Timer className="h-3.5 w-3.5" /> {mins}:{secs.toString().padStart(2, "0")}
    </div>
  );
}
